import VonalkodTesztlapTableService from 'app/admin/vonalkodtesztlap/service/VonalkodTesztlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';

const config = {
	key: 'vonalkodTesztlapTable',
	text: 'Vonalkod Tesztlap',
	textKey: 'chapters',
	service: VonalkodTesztlapTableService,
	icon: 'person',
	editFormState: item => `/vonalkodtesztlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltoTesztlapNev',
			text: 'Feltöltő',
			textKey: 'feltoltoTesztlapNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'feltoltesIdeje',
			text: 'Feltöltés ideje',
			textKey: 'feltoltesIdeje',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vonalkodVizsga',
			text: 'Vizsga vonalkódja',
			textKey: 'vonalkodVizsga',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'vonalkodVizsgazo',
			text: 'Vizsgázó vonalkód',
			textKey: 'vonalkodVizsgazo',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'hibaXML',
			text: 'Hiba',
			textKey: 'hibaXML',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function VonalkodTesztlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('vonalkodTesztlapTable', reducer('vonalkodTesztlapTable'))(VonalkodTesztlapTable);
